import { memo } from "react";

import {
  CalculatedMetricAdornment,
  CopyPreviousValueAdornment,
  InterpolatedMetricAdornment,
  WaterlyConnectAdornment,
} from "./adornments";

export type NumberInputStartAdornmentProps = {
  isWaterlyConnected?: boolean;
  isCalculated?: boolean;
  isInterpolated?: boolean;
  isInterpolatedValue?: boolean;
  isCopyPreviousValue?: boolean;
  copyPreviousValues?: {
    previousValue?: string | null;
    currentValue?: string | null;
  };
};

const defaultCopyPreviousValues = {
  previousValue: null,
  currentValue: null,
};

const NumberInputStartAdornment = ({
  isWaterlyConnected = false,
  isCalculated = false,
  isInterpolated = false,
  isInterpolatedValue = false,
  isCopyPreviousValue = false,
  copyPreviousValues = defaultCopyPreviousValues,
}: NumberInputStartAdornmentProps) => {
  if (isWaterlyConnected) {
    return <WaterlyConnectAdornment />;
  }
  if (isCalculated) {
    return <CalculatedMetricAdornment isInterpolatedValue={isInterpolatedValue} />;
  }
  if (isInterpolated) {
    return <InterpolatedMetricAdornment isInterpolatedValue={isInterpolatedValue} />;
  }
  if (isCopyPreviousValue) {
    return <CopyPreviousValueAdornment copyPreviousValues={copyPreviousValues} />;
  }
  return null;
};

export default memo(NumberInputStartAdornment);
